import { getArrayFromCacheOrFromEndpoint } from "../../utilities/cacheValidator";
import { IDocumentType, getDocumentTypesFromEndpoint } from "./storeRequests";
import { APIAnomalyError } from "../../services/ErrorHelpers";
import { IUserProviderState } from "../UserContext";

export async function getDocumentTypes(getTokenFn: IUserProviderState["accessToken"]): Promise<IDocumentType[]> {
  const documentTypes = await getArrayFromCacheOrFromEndpoint<IDocumentType[]>(
    "DocumentTypes",
    getDocumentTypesFromEndpoint,
    getTokenFn
  );
  return documentTypes;
}

export async function fetchAndParseDocumentTypes(getTokenFn: IUserProviderState["accessToken"]): Promise<string[]> {
  const documentTypeList = await getDocumentTypes(getTokenFn);
  if (documentTypeList.length === 0) {
    throw new APIAnomalyError("Received empty Array for Document Types");
  }
  return documentTypeList.map((item) => String(item.documentTypeCode));
}
